import { useContext } from 'react';

import { SelectInput } from '@interstate/components/SelectInput';
import type { FormSelectInputProps } from '../types';
import { FormContext } from './formContext';
import { dealLockHooks } from '../../hooks';

export const FormSelectInput = ({ name, label, options, errorMessage, maxHeight, placeholder, disable }: FormSelectInputProps) => {
    const { form, changeHandler } = useContext(FormContext);
    const isLocked = dealLockHooks.useIsDealLocked();

    return (
        <SelectInput
            data-testid={name}
            id={name}
            name={name}
            label={label}
            options={options}
            onChange={(ev) => changeHandler(name, ev.target.value as string)}
            maxHeight={maxHeight}
            placeholder={placeholder}
            value={form.values[name] as string}
            disabled={disable || isLocked}
            hasError={!!form.error[name]}
            errorMessage={form.error[name] ? errorMessage : undefined}
        />
    );
};
